
// Base.
import Vue from 'vue'
import { Prop, Mixins } from 'vue-property-decorator'
import Component from 'vue-class-component'
import usersMixins from './UsersMixin'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'

// Used Models.
import { User } from '../../models/user'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class GenerateLabels extends Vue {

  @Prop(Function) public readonly generateLabels!: (users: User[], firstComment: string, secondComment: string) => void
  @Prop() private readonly disabled!: boolean
  @Prop() private readonly users!: User[]
  @Prop() private isPending!: boolean
  @Prop() private isMenuItem: boolean

  private dialog: boolean = false
  private hasExtraField: boolean = false
  private firstComment: string = ''
  private secondComment: string = ''

  constructor() {
    super()
  }

  public mounted() {
    this.initialize()
  }

  private async save() {
    const isValid = await this.$validator.validateAll()
    if (isValid) {
      this.generateLabels(this.users, this.firstComment, this.secondComment)
      this.cancel()
    }
  }

  private initialize() {
    // TODO
  }

  private cancel() {
    this.hasExtraField = false
    this.firstComment = ''
    this.secondComment = ''
    this.dialog = false
  }
}
